/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：動態のAPI
 *
 * 作成者：2022/01/17 ノア）虞
 * 最終修正者：2022/01/17 ノア）虞
 *
 */
import { Vue } from 'vue-property-decorator'

import { apiClient } from '@/store/apis/apiClient'
import config from '@/config/config'
import {
  DynamicTargetParam,
  DynamicTargetData,
  MasterData,
  DynamicTargetMasterData,
  DynamicHistoryParam,
  DynamicHistoryData,
  DynamicPlaceParam
} from '@/models'

/**
 * 動態管理対象一覧を取得する
 *
 * @async
 * @param {DynamicTargetParam} dynamicTargetParam 動態管理対象のパラメータ
 * @returns {Promise<DynamicTargetData>} 動態管理対象一覧
 */
export async function getDynamicTargetData(dynamicTargetParam: DynamicTargetParam): Promise<DynamicTargetData> {
  const res = await apiClient.post(config.api.getDynamicTargetData, dynamicTargetParam)
  Vue.$log.debug('apis > getDynamicTargetData: res=', res)
  if (!res || !res.data) {
    throw new Error('apis > getDynamicTargetData: res is null')
  }
  return res.data.data as DynamicTargetData
}

/**
 * 管理場所を取得する
 *
 * @async
 * @param {DynamicPlaceParam} dynamicTargetParam 管理場所のパラメータ
 * @returns {Promise<MasterData>} 管理場所
 */
export async function getDynamicPlaceData(dynamicTargetParam: DynamicPlaceParam): Promise<MasterData> {
  const res = await apiClient.post(config.api.getManagementPlaceMapData, dynamicTargetParam)
  Vue.$log.debug('apis > getDynamicPlaceData: res=', res)
  if (!res || !res.data) {
    throw new Error('apis > getDynamicPlaceData: res is null')
  }
  return res.data.data as MasterData
}

/**
 * 管理場所詳細を取得する
 *
 * @async
 * @param {DynamicPlaceParam} dynamicTargetParam 管理場所詳細のパラメータ
 * @returns {Promise<MasterData>} 管理場所詳細
 */
export async function getDynamicPlaceDtlData(dynamicTargetParam: DynamicPlaceParam): Promise<MasterData> {
  const res = await apiClient.post(config.api.getManagementPlaceDetailMapData, dynamicTargetParam)
  Vue.$log.debug('apis > getDynamicPlaceDtlData: res=', res)
  if (!res || !res.data) {
    throw new Error('apis > getDynamicPlaceDtlData: res is null')
  }
  return res.data.data as MasterData
}

/**
 * 動態管理対象マスタを取得する
 *
 * @async
 * @param {DynamicTargetParam} dynamicTargetParam 動態管理対象のパラメータ
 * @returns {Promise<DynamicTargetData>} 動態管理対象一覧
 */
export async function getDynamicTargetMasterData(
  dynamicTargetParam: DynamicTargetParam
): Promise<DynamicTargetMasterData> {
  const res = await apiClient.post(config.api.getDynamicTargetMasterData, dynamicTargetParam)
  Vue.$log.debug('apis > getDynamicTargetMasterData: res=', res)
  if (!res || !res.data) {
    throw new Error('apis > getDynamicTargetMasterData: res is null')
  }
  return res.data.data as DynamicTargetMasterData
}

/**
 * 移動履歴一覧取得する
 *
 * @async
 * @param {DynamicHistoryParam} dynamicHistoryParam 移動履歴一覧のパラメータ
 * @returns {Promise<DynamicHistoryData>} 移動履歴一覧
 */
export async function getDynamicHistoryData(dynamicHistoryParam: DynamicHistoryParam): Promise<DynamicHistoryData> {
  const res = await apiClient.get(config.api.getDynamicHistoryData, {
    params: dynamicHistoryParam
  })

  Vue.$log.debug('apis > getDynamicHistoryData: res=', res)
  if (!res || !res.data) {
    throw new Error('apis > getDynamicHistoryData: res is null')
  }
  return res.data.data as DynamicHistoryData
}
